module.exports = __webpack_public_path__ + "static/media/nexatlas-black.5ad81ddf.svg";